<!--
 * @Description: 新增人员-服务授权面板组件
 * @Author: wanqian
 * @Date: 2022-03-28 11:24:06
-->
<template>
  <div class="service-authorization-body">
    <el-form v-if="serviceAuthorizationForm && serviceAuthorizationForm.attendant" class="serviceAuthorizationForm" 
      ref="serviceAuthorizationForm" :model="serviceAuthorizationForm.attendant" :rules="rules" 
      label-position="top" label-width="100px">
      <el-row style="margin: 0 5px" :gutter="50" type="flex" justify="space-between"  >
				<el-form-item label="服务类别：" prop="serviceType">
					<el-radio-group v-model="serviceAuthorizationForm.attendant.serviceType" :disabled="readonly">
						<el-radio v-for="(value, key) in serviceAuthorizationForm.serviceTypeMap" 
              :key="key" :label="parseInt(key)">
              {{value}}
            </el-radio>
					</el-radio-group>
				</el-form-item>
			</el-row>
    </el-form>
    <div class="bk-wizard-bottons">
      <wizard-buttons :mode="mode" :status="btnStatus" :reviewBtn="attendantPrivilege && attendantPrivilege.canReview" 
        @btnpressed="handleBtnSelection" />
    </div>
  </div>
</template>

<script>
import attendantStore from './AttendantStore.js'

let AttendantServiceAuthorizationPanel = {
  name: 'AttendantServiceAuthorizationPanel',
  attendantStore,
  
  data() {
    return {
      btnStatus: {'prev': true, 'next': false, 'submit': true},
      rules: {
        serviceType: [{required: true, message: '请选择服务类别', trigger: 'blur' },],
      },
    }
  },
  
  computed: {
    mode() {
      return attendantStore.state.mode;
    },

    readonly() {
      return attendantStore.state.mode == 'details';
    },

    serviceAuthorizationForm() {
      return attendantStore.state.attendantDo;
    },

    attendantPrivilege() {
      return attendantStore.state.attendantPrivilege;
    },
  },

  methods: {
    handleBtnSelection(operate) {
      if (this.mode == 'details' || operate != 'next' && operate != 'add' && operate != 'edit') {
        this.$emit("panel-operate", operate);
        return true;
      }

      this.$refs.serviceAuthorizationForm.validate((valid) => {
        if (!valid) return false;
        else {
          this.$emit("panel-operate", operate);
          return true;
        }
      });
    },
  },

  destroyed() {
    //销毁的时候同步数据
    attendantStore.commit('changeAttendantDo', this.serviceAuthorizationForm);
  },
}
export default AttendantServiceAuthorizationPanel
</script>

<style scoped>
.service-authorization-body {
	margin: 20px 12px;
}
.serviceAuthorizationForm {
  margin-bottom: 100px;
}
.el-tag {
  border: 1px solid #DFE2E5;
  color: #7689A6;
  background-color: #F3F5F7;
  margin: 0 10px 5px 0;
}
</style>

<style>
.service-authorization-body .el-form-item {
	margin-bottom: 20px;
}
.service-authorization-body .el-form--label-top .el-form-item__label {
	padding: 0px;
	line-height: 26px;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/attendantdetails/AttendantServiceAuthorizationPanel.vue